export default __webpack_public_path__ + "static/media/scan-bunifikasi-logotype-d.4e37c15f.svg";